import { render, staticRenderFns } from "./GenderSetting.vue?vue&type=template&id=fa0e4380"
import script from "./GenderSetting.vue?vue&type=script&lang=js"
export * from "./GenderSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports